import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PriceSecOne = ({ className }) => {
    const { t } = useTranslation();
  

        const plans = t('sections.priceSecOne.plans', { returnObjects: true, defaultValue: [
            {
                name: 'Basic Plan',
                description: 'Small to medium-sized businesses, including those in retail, healthcare.',
                price: '$45,00',
                availableCount: 3,
                features: [
                    'Regular vulnerability assessments',
                    'Regular penetration testing',
                    'Incident response planning',
                    'Regular vulnerability assessments',
                    '24/7 security monitoring'
                ]
            },
            {
                name: 'Standard Plan',
                description: 'Growing businesses that need comprehensive security solutions to',
                price: '$99,00',
                popular: true,
                availableCount: 4,
                features: [
                    'Regular vulnerability assessments',
                    'Regular penetration testing',
                    'Incident response planning',
                    'Regular vulnerability assessments',
                    '24/7 security monitoring'
                ]
            },
            {
                name: 'Premium Plan',
                description: 'Large organizations with complex IT infrastructures and stringent security',
                price: '$150,00',
                availableCount: 5,
                features: [
                    'Regular vulnerability assessments',
                    'Regular penetration testing',
                    'Incident response planning',
                    'Regular vulnerability assessments',
                    '24/7 security monitoring'
                ]
            }
        ] });

        return (
                <section className={className} >
            <div
                className="shape-mockup bg-gradient-shape1 price-bg-gradient1"
                data-top="15%"
                data-left="3%"
            />
            <div className="container">
                <div className="title-area text-center">
                <span className="sub-title" data-cue="slideInUp">{t('sections.priceSecOne.sub_title','Pricing Plan')}</span>
                <h2 className="sec-title" data-cue="slideInUp" dangerouslySetInnerHTML={{ __html: t('sections.priceSecOne.title','Affordable Cyber Security <br /> Solutions') }} />
                </div>
                                <div className="row gy-4 justify-content-center">
                                {plans.map((plan, idx) => {
                                    // Determine available count based on plan index (0=Basic:3, 1=Standard:4, 2=Premium:5)
                                    // Fallback to plan.availableCount if available from translation
                                    const availableCount = plan.availableCount !== undefined ? plan.availableCount : (idx === 0 ? 3 : idx === 1 ? 4 : 5);
                                    return (
                                    <div className="col-lg-4 col-md-6" data-cue="slideInUp" key={idx}>
                                        <div className={`price-card ${plan.popular ? 'active' : ''}`}>
                                            <span className="price-tag">{plan.popular ? t('sections.priceSecOne.popular','Popular') : ''}</span>
                                            <h3 className="box-title">{plan.name}</h3>
                                            <p className="box-text">{plan.description}</p>
                                            <div className="box-price">{plan.price}<span className="duration">{t('sections.priceSecOne.duration','/month')}</span></div>
                                            <Link to="/pricing" className="ot-btn style-border w-100">{t('sections.priceSecOne.get_started','Get Started')}</Link>
                                            <div className="box-content">
                                                <div className="check-list">
                                                    <ul>
                                                        { (plan.features || []).map((f, i) => (
                                                            <li key={i} className={i >= availableCount ? 'unavailable' : ''}>
                                                                <i className={`${i < availableCount ? 'fas' : 'far'} fa-circle-check`} /> {f}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    );
                                })}
                                </div>
            </div>
        </section>

    );
};

export default PriceSecOne;